import { render, staticRenderFns } from "./politica-de-envios-a-domicilios.vue?vue&type=template&id=a820a30a&lang=html&"
import script from "./politica-de-envios-a-domicilios.vue?vue&type=script&lang=js&"
export * from "./politica-de-envios-a-domicilios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports